// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__2ku94","cardExpanded":"card_cardExpanded__3_rz-"};